import { Component, OnInit, Renderer2, ViewChild, ElementRef, Directive } from '@angular/core';
import { ROUTES } from '../.././sidebar/sidebar.component';
import { Router, ActivatedRoute, NavigationEnd, NavigationStart } from '@angular/router';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { showNotification } from 'src/app/utils/notifications/showNotification';
import { TakeLists } from 'src/app/services/take_lists.service';
import { calcularDias } from 'src/app/utils/dates/dates';
import { debounceTime, Subject } from 'rxjs'
const misc: any = {
    navbar_menu_visible: 0,
    active_collapse: true,
    disabled_collapse_init: 0,
};

declare var $: any;

declare interface Notification {
    title: String;
    client: String;
    days: number;
    report_id: String;
}

@Component({
    selector: 'app-navbar-cmp',
    templateUrl: 'navbar.component.html'
})

export class NavbarComponent implements OnInit {
    @ViewChild('notifications') notificationsRef!: ElementRef;

    private listTitles: any[];
    location: Location;
    mobile_menu_visible: any = 0;
    private nativeElement: Node;
    private toggleButton: any;
    private sidebarVisible: boolean;
    private _router: Subscription;
    private _take_list: TakeLists;
    public notifications: Notification[] = [];
    public notificationsQuantity: number = 0;

    @ViewChild('app-navbar-cmp', { static: false }) button: any;

    constructor(location: Location, private renderer: Renderer2, private element: ElementRef, private router: Router, private take_list: TakeLists) {
        this.location = location;
        this.nativeElement = element.nativeElement;
        this.sidebarVisible = false;
    }
    minimizeSidebar() {
        const body = document.getElementsByTagName('body')[0];

        if (misc.sidebar_mini_active === true) {
            body.classList.remove('sidebar-mini');
            misc.sidebar_mini_active = false;

        } else {
            setTimeout(function () {
                body.classList.add('sidebar-mini');

                misc.sidebar_mini_active = true;
            }, 300);
        }

        // we simulate the window Resize so the charts will get updated in realtime.
        const simulateWindowResize = setInterval(function () {
            window.dispatchEvent(new Event('resize'));
        }, 180);

        // we stop the simulation of Window Resize after the animations are completed
        setTimeout(function () {
            clearInterval(simulateWindowResize);
        }, 1000);
    };

    hideSidebar() {
        const body = document.getElementsByTagName('body')[0];
        const sidebar = document.getElementsByClassName('sidebar')[0];

        if (misc.hide_sidebar_active === true) {
            setTimeout(function () {
                body.classList.remove('hide-sidebar');
                misc.hide_sidebar_active = false;
            }, 300);
            setTimeout(function () {
                sidebar.classList.remove('animation');
            }, 600);
            sidebar.classList.add('animation');

        } else {
            setTimeout(function () {
                body.classList.add('hide-sidebar');
                // $('.sidebar').addClass('animation');
                misc.hide_sidebar_active = true;
            }, 300);
        }

        // we simulate the window Resize so the charts will get updated in realtime.
        const simulateWindowResize = setInterval(function () {
            window.dispatchEvent(new Event('resize'));
        }, 180);

        // we stop the simulation of Window Resize after the animations are completed
        setTimeout(function () {
            clearInterval(simulateWindowResize);
        }, 1000);
    };

    searchChanged = new Subject<string>();

    ngOnInit() {
        this.listTitles = ROUTES.filter(listTitle => listTitle);

        this.minimizeSidebar();

        this.searchChanged.pipe(
            debounceTime(300)
        ).subscribe(query => {
            this.filtered = this.commands.filter(cmd =>
                cmd.name.toLowerCase().includes(query.toLowerCase()) ||
                cmd.keywords.toLowerCase().includes(query.toLowerCase())
            );
        });

        const navbar: HTMLElement = this.element.nativeElement;
        const body = document.getElementsByTagName('body')[0];
        this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
        if (body.classList.contains('sidebar-mini')) {
            misc.sidebar_mini_active = true;
        }
        if (body.classList.contains('hide-sidebar')) {
            misc.hide_sidebar_active = true;
        }
        this._router = this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
            this.sidebarClose();

            const $layer = document.getElementsByClassName('close-layer')[0];
            if ($layer) {
                $layer.remove();
            }
        });

        // Escuta cada NavigationEnd
        this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                this.updateNotification();
            }
        });

        this.updateNotification();
    };

    onInputChange() {
        this.searchChanged.next(this.query);
    }

    onResize(event) {
        if ($(window).width() > 991) {
            return false;
        }
        return true;
    };

    navigate(path: string) {
        this.router.navigate([path]);
        this.filtered = [];
        this.query = '';
    }


    query = '';
    filtered: { name: string, keywords: string, path: string }[] = [];

    commands = [
        {
            name: 'Saúde',
            keywords: 'saude saúde mental física bem-estar',
            path: '/saude'
        },
        {
            name: 'Finanças',
            keywords: 'dinheiro planejamento orçamento',
            path: '/financas'
        },
        {
            name: 'Sono',
            keywords: 'sono descanso cronotipo',
            path: '/sono'
        },
        {
            name: 'Atividade Física',
            keywords: 'exercício academia esportes treino',
            path: '/atividade-fisica'
        }
    ];


    sidebarOpen() {
        var $toggle = document.getElementsByClassName('navbar-toggler')[0];
        const toggleButton = this.toggleButton;
        const body = document.getElementsByTagName('body')[0];
        setTimeout(function () {
            toggleButton.classList.add('toggled');
        }, 500);
        body.classList.add('nav-open');
        setTimeout(function () {
            $toggle.classList.add('toggled');
        }, 430);

        var $layer = document.createElement('div');
        $layer.setAttribute('class', 'close-layer');


        if (body.querySelectorAll('.main-panel')) {
            document.getElementsByClassName('main-panel')[0].appendChild($layer);
        } else if (body.classList.contains('off-canvas-sidebar')) {
            document.getElementsByClassName('wrapper-full-page')[0].appendChild($layer);
        }

        setTimeout(function () {
            $layer.classList.add('visible');
        }, 100);

        $layer.onclick = function () { //asign a function
            body.classList.remove('nav-open');
            this.mobile_menu_visible = 0;
            this.sidebarVisible = false;

            $layer.classList.remove('visible');
            setTimeout(function () {
                $layer.remove();
                $toggle.classList.remove('toggled');
            }, 400);
        }.bind(this);

        body.classList.add('nav-open');
        this.mobile_menu_visible = 1;
        this.sidebarVisible = true;
    };

    sidebarClose() {
        var $toggle = document.getElementsByClassName('navbar-toggler')[0];
        const body = document.getElementsByTagName('body')[0];
        this.toggleButton.classList.remove('toggled');
        var $layer = document.createElement('div');
        $layer.setAttribute('class', 'close-layer');

        this.sidebarVisible = false;
        body.classList.remove('nav-open');
        // $('html').removeClass('nav-open');
        body.classList.remove('nav-open');
        if ($layer) {
            $layer.remove();
        }

        setTimeout(function () {
            $toggle.classList.remove('toggled');
        }, 400);

        this.mobile_menu_visible = 0;
    };

    sidebarToggle() {
        if (this.sidebarVisible === false) {
            this.sidebarOpen();
        } else {
            this.sidebarClose();
        }
    };

    build() {
        showNotification('bottom', 'left', 'warning', 'Infelizmente essa funcionalidade ainda não foi construída.');
    };

    voltar(): void {
        this.location.back();
    }

    getBackOption() {
        return true
    };

    getTitle() {
        var titlee = this.location.prepareExternalUrl(this.location.path());
        if (titlee.charAt(0) === '#') {
            titlee = titlee.slice(1);
        }
        for (let i = 0; i < this.listTitles.length; i++) {
            if (this.listTitles[i].type === "link" && this.listTitles[i].path === titlee) {
                return this.listTitles[i].title;
            } else if (this.listTitles[i].type === "sub") {
                for (let j = 0; j < this.listTitles[i].children.length; j++) {
                    let subtitle = this.listTitles[i].path + '/' + this.listTitles[i].children[j].path;
                    if (subtitle === titlee) {
                        return this.listTitles[i].children[j].title;
                    }
                }
            }
        }
        return 'IFPTool';
    };

    getPath() {
        return this.location.prepareExternalUrl(this.location.path());
    };

    async updateNotification() {
        console.log('Atualizando notificações...');

        let isLogged = (localStorage.getItem("current_id") || '') !== '';
        if (!isLogged) {
            console.error('Usuário não está logado.');
            return;
        };

        let storedUsers = JSON.parse(localStorage.getItem("users") || "[]");

        let attempts = 0;
        let maxRetries = 15;
        while (storedUsers.length === 0 && attempts < maxRetries) {
            console.log('Tentativa de recuperação de usuários: ' + (attempts + 1));
            // Aguarda 1 segundo
            await new Promise(resolve => setTimeout(resolve, 1000));
            storedUsers = JSON.parse(localStorage.getItem('users') || '[]');
            attempts++;
        };

        if (storedUsers.length === 0) {
            console.error('Falha ao recuperar usuários após várias tentativas.');
            return;
        };

        const notifications = await this.take_list.takePendents();
        const estudos = await this.take_list.getReports();
        const clients = await this.take_list.getUsers();

        const mapaClient = clients.reduce((map, client) => {
            map[client.id] = client.full_name;
            return map;
        }, {});

        const mapaEstudosAndUser = estudos.reduce((map, report) => {
            map[report.id] = {
                title: report.title,
                client: mapaClient[report.client_id],
                report_id: report.id
            }
            return map;
        }, {});


        const updatedNotifications: Notification[] = notifications
            // Filtra para retornar apenas o primeiro item de cada report_id
            .filter((notification, index, self) =>
                index === self.findIndex(n => n.report_id === notification.report_id)
            )
            .map(notification => {
                return {
                    ...mapaEstudosAndUser[notification.report_id],
                    days: calcularDias(notification.updated_at)
                }
            })
            .sort((a, b) => {
                if (a.days < b.days) return -1;
                if (a.days > b.days) return 1;
                return 0;
            });

        this.notificationsQuantity = updatedNotifications.length;
        this.notifications = this.notificationsQuantity === 0 ? new Array<Notification>() : updatedNotifications;
    };

    goToDashboard(reportId: string) {
        // Verifica se a rota atual inicia com "/dashboard"
        const isOnDashboard = this.router.url.startsWith('/dashboard');
        this.router.navigate(['/dashboard'], {
            queryParams: { estudo_id: reportId }
        });

        if (isOnDashboard) {
            location.reload();
        };
    }

}
